// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lineTableHeader_headerContainer_c7jG3 {
  display: block;
  break-inside: avoid;
  break-before: avoid-page;
  margin-bottom: 1.3rem;
}

.lineTableHeader_flexHeader_BGIei {
  display: flex;
}

.lineTableHeader_stop_E4Dtx {
  flex-grow: 1;
  height: 50px;
  padding-right: 16px;
  margin-bottom: 1rem;
}

.lineTableHeader_stopNamePrimary_e_M4D {
  font-size: 1rem;
  margin: 0 0 0.2rem 1.2rem;
  font-family: GothamRounded-Medium;
  letter-spacing: normal;
  break-inside: avoid;
}

.lineTableHeader_stopNameSecondary_W_KC3 {
  font-size: 1rem;
  margin: 0 0 0 1.2rem;
  font-family: GothamRounded-Book;
  letter-spacing: normal;
}

.lineTableHeader_directionBracket_rQyUP {
  font-family: GothamRounded-Medium;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/lineTimetable/lineTableHeader.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB","sourcesContent":[".headerContainer {\n  display: block;\n  break-inside: avoid;\n  break-before: avoid-page;\n  margin-bottom: 1.3rem;\n}\n\n.flexHeader {\n  display: flex;\n}\n\n.stop {\n  flex-grow: 1;\n  height: 50px;\n  padding-right: 16px;\n  margin-bottom: 1rem;\n}\n\n.stopNamePrimary {\n  font-size: 1rem;\n  margin: 0 0 0.2rem 1.2rem;\n  font-family: GothamRounded-Medium;\n  letter-spacing: normal;\n  break-inside: avoid;\n}\n\n.stopNameSecondary {\n  font-size: 1rem;\n  margin: 0 0 0 1.2rem;\n  font-family: GothamRounded-Book;\n  letter-spacing: normal;\n}\n\n.directionBracket {\n  font-family: GothamRounded-Medium;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `lineTableHeader_headerContainer_c7jG3`,
	"flexHeader": `lineTableHeader_flexHeader_BGIei`,
	"stop": `lineTableHeader_stop_E4Dtx`,
	"stopNamePrimary": `lineTableHeader_stopNamePrimary_e_M4D`,
	"stopNameSecondary": `lineTableHeader_stopNameSecondary_W_KC3`,
	"directionBracket": `lineTableHeader_directionBracket_rQyUP`
};
module.exports = ___CSS_LOADER_EXPORT___;
